// ----- Handles specific JS functionality to the account area -----

// const sortingForm = "account-sorting-form";
// const allowLoginId = "user-allow-login";
// const allBranchesId = "user-all-branches";
// const selectBranches = "user-branches-select-button";
// const branchSelectGroup = "input.branch-select-input-group";
// var totalBranchesSelected = 0;
// var totalBranches = $('#select-branches-table input.branch-select-input-group').length;

// if ($('.' + sortingForm).length > 0) {
//     accountSortInitialise();
// }

// TODO: this needs to go as we can now use data-ajax-form
// function accountSortInitialise() {
//     $('body').on('submit', '.' + sortingForm, function(event) {
//         event.stopImmediatePropagation();
//         // Prevent default functionality.
//         event.preventDefault();
//         let data = $('.' + sortingForm).serialize();
//         // Prepare to post!.
//         let post = accountPost($('.' + sortingForm), data);
//     });
// }

// function accountPost(form, data) {
//     //Call post url function to determine post location.
//     let AJAXPostURL = AXISAjax.postUrl(form, false, true);

//     if (!AJAXPostURL) {
//         AXISDebug.output(3,"Account JS: Failed to get callback url");
//         return false;
//     }

//     // Post to server.
//     AXISAjax.post(AJAXPostURL, data, 'html', form, true).then((data) => {
//         // Get response.
//         let response = data['data'];
//         $('.callbackListContainer').html(response);

//         accountSortInitialise();

//         AXISBranchSwitcher.initialise();

//         // Clear equalise instance obj.
//         textEqualiseObj = {};
        
//         // Initialise each cell.
//         $('.callbackListContainer table .text-container').each(function() {
//             // Store context.
//             let item = $(this);
//             initialiseTextEqualise(item);
//         });

//         $('.callbackListContainer').find('.control.select').each(function() {
//             let item = $(this);
//             let initalise = AXISInputs.initaliseControlSelect(item);
//         });
//     });
// }

function reloadTokens(postUrl = "", data = "", callbackMessage = "") {
    // Make sure all data is here for ajax post.
    if (postUrl == "") {
        AXISDebug.output(3,"Tokens: You must provide a callback url.");
        return false;
    } 
    if (data == "") {
        if (AXISDebug.level() >= 2) {
            AXISDebug.output(2,"Tokens: Reloading tokens without any data.");
        }
    }
    // Tokens container.
    let container = $('#tokens-container');
    // Check if tokens actual existed.
    if (container.length > 0) {
        if (AXISDebug.level() >= 2) {
            AXISDebug.output(1,"Tokens: Attempting to refresh token list.");
        }
        AXISAjax.post(postUrl, data, "json", container).then((data) => {
            // Get response.
            let response = data['data'];
            container.html(response['tokens']);
            // Close Modal.
            AXISModals.modalClose();
            // Initialise radio buttons.
            let radios = AXISInputs.initialiseControlRadios();
            // Bring the tokens list into view.
            Foundation.SmoothScroll.scrollToLoc($('#tokens-container'), {offest: 120})
        });
        if (callbackMessage) {
            let callout = callouts.create($(callbackMessage).text(), "", undefined, $(callbackMessage).data('close-delay'));
        }
    } else {
        AXISDebug.output(2,"Tokens: No tokens container which indicates tokens were never active on this page");
        return false;
    }
}

// ----- Equalise text content ----- 
function initialiseTextEqualise(context) {
    if (!context) {
        AXISDebug.output(3,"Table Text Equalise: Context is not defined exiting function");
        return false;
    }
    // Get Parent.
    let parent = context.parents('td').attr('class');
    // Check if group has been initialised.
    if (!textEqualiseObj.hasOwnProperty(parent)) {
        textEqualiseObj[parent] = {};
    }
    // Get width.
    let width = context[0].getBoundingClientRect().width;
    // Check if this column has any pdf's.
    let hasPDF = context.find('.pdf-download').length;
    // Assign column pdf status to instance.
    if (hasPDF > 0) {
        textEqualiseObj[parent]['has-pdf'] = true;
    } else if (textEqualiseObj[parent]['has-pdf'] == undefined) {
        textEqualiseObj[parent]['has-pdf'] = false;
    }
    
    // Get widths array.
    let widthArray = textEqualiseObj[parent]['widths'];
    // Make sure array exists otherwise initialise.
    if (!$.isArray(widthArray)) {
        widthArray = [];
    }
    // Push to array.
    widthArray.push(width)
    // Assign array to instance.
    textEqualiseObj[parent]['widths'] = widthArray;
    
    return true;
};

if ($('.current-price-saving').length > 0) {
    $('.current-price-saving').on('mouseenter mouseleave', function() {
        let context= $(this);
        let button = context.parents('tr').find('.add-to-basket');
        button.toggleClass('hover');
    });
}

var AXISAccount = $.AXISAccount = {
    initialiseEqualise: (context, ajax = false) => {  
        // Clear equalise instance obj.
        if (ajax) {
            textEqualiseObj = {};
        }
        // Initialise each cell.
        context.each(function() {
            // Store context.
            let item = $(this);
            initialiseTextEqualise(item);
        });
    },
    reloadTokens: (postUrl, data, callbackMessage) => {
        return reloadTokens(postUrl, data, callbackMessage);
    }
}
  
export { AXISAccount };





